/**
 * @author: Abdul Pathan
 */
import React, { useState, useRef } from 'react'
import { Image, Modal } from 'react-bootstrap'
import { Col, Form, Row } from "react-bootstrap";
import HRMSApi from '../../api/HRMSApi';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const UpdateImage = ({ show, onHide, imageRefresh }) => {
    const [body, setBody] = useState(show);
    const [base64String, setBase64String] = useState('');
    const [fileDetails, setFileDetails] = useState({ name: '', type: '' });
    const fileInputRef = useRef(null);
    const formRef = useRef(null);
    const [fileError, setFileError] = useState('');
    const [fileErrorLimit, setFileErrorLimit] = useState('');
    const [isFormChanged, setIsFormChanged] = useState(true);
    const [isSpinner, setIsSpinner] = useState(true);

    const fileHandleChange = (event) => {
        const file = event.target.files[0];

        const allowedFormats = ['image/jpeg', 'image/jpg', 'image/png'];
        const maxSize = 3 * 1024 * 1024; // 3 MB in bytes

        if (file) {

            if (!allowedFormats.includes(file.type)) {
                formRef.current.reset();
                setFileDetails({ name: '', type: '' });

                setFileErrorLimit('');
                setFileError('Only JPG, JPEG, and PNG formats are allowed');
                event.target.value = null;
            }
            else if (file.size > maxSize) {
                formRef.current.reset();
                setFileDetails({ name: '', type: '' });
                setFileError('');
                setFileErrorLimit('File size exceeds the maximum limit of 3 MB');
            }
            else {
                setBody({ ...body, url: URL.createObjectURL(event.target.files[0]) });
                const reader = new FileReader();
                reader.onloadend = () => {
                    const fileContent = reader.result.split(",")[1];
                    setBase64String(fileContent);
                };
                reader.readAsDataURL(file);
                setFileDetails({ name: file.name, type: file.type.split("/")[1] });
                setFileError('');
                setFileErrorLimit('');
            }
        }
        else { // If no file is selected, clear the error message and file name
            // setFileContainError('');
            setFileError('');
            setFileDetails({ name: '', type: '' });
        }
    }

    // File uplaod
    const handleFileInputClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    }
    // handle submit
    const handleSubmit = async () => {
        if (fileDetails.type && base64String) {
            setIsSpinner(false)
            setIsFormChanged(false);
            // const fileNameWithoutExtension = fileDetails.name.split('.')[0];
            // let imgData = { "name": body.name, "fileName": fileNameWithoutExtension, "contentType": fileDetails.type, "base64File": base64String };
            let imgData = { "fileName": body.name, "contentType": fileDetails.type, "base64File": base64String };
            const result = await HRMSApi.insertImage(imgData);
            //console.log('##result', result)
            if (result.success) {
                imageRefresh();
                toast.success(result.message, { position: toast.POSITION.TOP_RIGHT });
            } else {
                setIsSpinner(true);
            }
        } else {
            toast.error('Please select file.', { position: toast.POSITION.TOP_RIGHT });
        }
    }

    return (
        <>
            <Modal show={show} animation={false} centered size='md' >
                <Modal.Header closeButton onHide={onHide}>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Upload Image
                    </Modal.Title>
                </Modal.Header>
                {isSpinner ?
                    <Modal.Body className='profile-modal position-relative' style={{ minHeight: "400px" }}>

                        <Row className='text-center'>
                            <Col lg={12}>
                                <Image
                                    src={body.url}
                                    style={{ height: "250px", width: "250px", objectFit: "cover" }}
                                    thumbnail
                                />
                            </Col>
                        </Row>

                        <Row className='text-center mt-3'>
                            <Col lg={12}>
                                <Form ref={formRef}>
                                    <Form.Group>

                                        <div
                                            onClick={handleFileInputClick}
                                            style={{
                                                border: "2px dashed #ccc",
                                                padding: "15px",
                                                borderRadius: "10px",
                                                cursor: "pointer"
                                            }}
                                        >
                                            <i className="fa-solid fa-cloud-arrow-up fs-3 text-primary"></i>
                                            <div>{fileDetails?.name || "Click to upload image"}</div>
                                        </div>

                                        <Form.Control
                                            hidden
                                            type="file"
                                            accept=".jpg, .jpeg, .png"
                                            onChange={fileHandleChange}
                                            ref={fileInputRef}
                                        />

                                        {fileError && <div className="text-danger mt-2">{fileError}</div>}
                                        {fileErrorLimit && <div className="text-danger">{fileErrorLimit}</div>}

                                    </Form.Group>
                                </Form>
                            </Col>
                        </Row>

                    </Modal.Body>
                    :
                    <div>
                        <div className="sk-cube-grid">
                            <div className="sk-cube sk-cube1"></div>
                            <div className="sk-cube sk-cube2"></div>
                            <div className="sk-cube sk-cube3"></div>
                            <div className="sk-cube sk-cube4"></div>
                            <div className="sk-cube sk-cube5"></div>
                            <div className="sk-cube sk-cube6"></div>
                            <div className="sk-cube sk-cube7"></div>
                            <div className="sk-cube sk-cube8"></div>
                            <div className="sk-cube sk-cube9"></div>
                        </div>
                    </div>
                }
                <Modal.Footer className='position-absolute bottom-0 w-100'>
                    <button className='btn btn-outline-primary' onClick={onHide} disabled={!isFormChanged}>Close</button>
                    <button className='btn btn-outline-primary' onClick={handleSubmit} disabled={!isFormChanged}>Save</button>
                </Modal.Footer>
            </Modal>

        </>
    )
}

export default UpdateImage